import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    document.body.style.overflow = "hidden";
  }

  disconnect() {
    document.body.style.overflow = "";
  }

  close() {
    const frame = document.getElementById("recipe_picker_modal");
    if (frame) {
      frame.innerHTML = "";
    }
    document.body.style.overflow = "";
  }

  stop(event) {
    event.stopPropagation();
  }
}
